export default __webpack_public_path__ + "static/media/2017-AMcover.0ca646ae.png";